import React from "react";
import Col from "react-bootstrap/Col";

import "./Footer.scss";

class Footer extends React.Component {
  render() {
    return (
      <Col md={12} className="copyright">
        <div className="Copyright_text">© 2022-2023 Sanerret</div>
      </Col>
    );
  }
}
export default Footer;
